import { render } from "./DashboardOrderDetails.vue?vue&type=template&id=57abfa60"
import script from "./DashboardOrderDetails.vue?vue&type=script&lang=js"
export * from "./DashboardOrderDetails.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__